import React from "react";
import "./Blur.css"

const Blur = () => {
  return (
    <>
      <div className="blur-bg">
        <div className="blur-one"></div>
        <div className="blur-two"></div>
        <div className="blur-three"></div>
      </div>
    </>
  );
};

export default Blur;
